export const setLossControlValueHelper = (value: string | undefined, defaultValue: string) =>
  value == null || value === 'NotSet' ? defaultValue : value;
